import EntityModel from '@/common/models/entity-model';
import RuleActionModel from '@/common/models/rules/actions/rule-action-model';
import AddNsfFeeActionModel from '@/common/models/rules/actions/add-nsf-fee-action-model';
import AddRiskScoreActionModel from '@/common/models/rules/actions/add-risk-score-action-model';
import BlacklistActionModel from '@/common/models/rules/actions/blacklist-action-model';
import CriteriaCondition from '@/components/query/spec/criteria-condition';
import OfferPurchaseBumpActionModel from '@/common/models/rules/actions/offer-purchase-bump-action-model';
import PickGatewayAccountActionModel from '@/common/models/rules/actions/pick-gateway-account-action-model';
import RequestKYCActionModel from '@/common/models/rules/actions/request-kyc-action-model';
import ScheduleInvoiceRetryActionModel from '@/common/models/rules/actions/schedule-invoice-retry-action-model';
import SchedulePaymentActionModel from '@/common/models/rules/actions/schedule-payment-action-model';
import SchedulePaymentRetryActionModel from '@/common/models/rules/actions/schedule-payment-retry-action-model';
import SendEmailActionModel from '@/common/models/rules/actions/send-email-action-model';
import ShowDescriptorDisclaimerActionModel from '@/common/models/rules/actions/show-descriptor-disclaimer-action-model';
import TagOrUntagCustomerActionModel from '@/common/models/rules/actions/tag-or-untag-customer-action-model';
import TriggerWebhookActionModel from '@/common/models/rules/actions/trigger-webhook-action-model';
import DisplayOtherChoicesActionModel from '@/common/models/rules/actions/display-other-choices-action-model';
import ScheduleReminderActionModel from '@/common/models/rules/actions/schedule-reminder-action-model';
import ResetReminderActionModel from '@/common/models/rules/actions/reset-reminder-action-model';
import RemoveReminderActionModel from '@/common/models/rules/actions/remove-reminder-action-model';
import CreateKeapInfusionsoftOrderModel from '@/common/models/rules/actions/create-keap-infusionsoft-order';
import CreateKeapInfusionsoftPaymentModel from '@/common/models/rules/actions/create-keap-infusionsoft-payment';


export default class RuleModel extends EntityModel {
    static Statuses = {
        active: 'active',
        inactive: 'inactive',
    };

    static Types = {
        rule: {
            type: 'rule',
            family: 'rules',
        },
        bind: {
            type: 'bind',
            family: 'binds',
        },
    };

    hydrate({
        name = null,
        labels = null,
        status = 'active',
        criteria = null,
        actions = [],
        final = true,
        order = 0,
    } = {}) {
        this.name = name;
        this.labels = labels;
        this.status = RuleModel.convertStringStatus(status);
        this.criteria = criteria ? new CriteriaCondition(criteria) : null;
        this.actions = RuleModel.mapRuleActions(actions);
        this.final = final;
        // Used internally for determining the position of the rule.
        this.order = order;
    }

    static mapRuleActions(actions) {
        return actions.map((action) => {
            switch (action.name) {
                case RuleActionModel.Names.addRiskScore:
                    return new AddRiskScoreActionModel(action);
                case RuleActionModel.Names.blacklist:
                    return new BlacklistActionModel(action);
                case RuleActionModel.Names.pickGatewayAccount:
                    return new PickGatewayAccountActionModel(action);
                case RuleActionModel.Names.requestKyc:
                    return new RequestKYCActionModel(action);
                case RuleActionModel.Names.schedulePayment:
                    return new SchedulePaymentActionModel(action);
                case RuleActionModel.Names.schedulePaymentRetry:
                    return new SchedulePaymentRetryActionModel(action);
                case RuleActionModel.Names.sendEmail:
                    return new SendEmailActionModel(action);
                case RuleActionModel.Names.triggerWebhook:
                    return new TriggerWebhookActionModel(action);
                case RuleActionModel.Names.addNsfFee:
                    return new AddNsfFeeActionModel(action);
                case RuleActionModel.Names.showDescriptorDisclaimer:
                    return new ShowDescriptorDisclaimerActionModel(action);
                case RuleActionModel.Names.offerPurchaseBump:
                    return new OfferPurchaseBumpActionModel(action);
                case RuleActionModel.Names.scheduleInvoiceRetry:
                    return new ScheduleInvoiceRetryActionModel(action);
                case RuleActionModel.Names.tagOrUntagCustomer:
                    return new TagOrUntagCustomerActionModel(action);
                case RuleActionModel.Names.displayOtherChoices:
                    return new DisplayOtherChoicesActionModel(action);
                case RuleActionModel.Names.scheduleReminder:
                    return new ScheduleReminderActionModel(action);
                case RuleActionModel.Names.resetReminder:
                    return new ResetReminderActionModel(action);
                case RuleActionModel.Names.removeReminder:
                    return new RemoveReminderActionModel(action);
                case RuleActionModel.Names.createKeapInfusionsoftOrder:
                    return new CreateKeapInfusionsoftOrderModel(action);
                case RuleActionModel.Names.createKeapInfusionsoftPayment:
                    return new CreateKeapInfusionsoftPaymentModel(action);
                default:
                    // generic rule actions that don't need
                    // special fields fallback here
                    return new RuleActionModel(action);
            }
        });
    }

    getPayload() {
        return {
            name: this.name,
            labels: this.labels,
            status: RuleModel.convertBooleanStatus(this.status),
            criteria: this.criteria ? this.criteria.getPayload() : null,
            actions: this.actions.map(action => action.getPayload()),
            final: this.final,
        };
    }

    /* eslint-disable */
    get isBind() {
        return false;
    }
    /* eslint-enable */

    get type() {
        return this.isBind
            ? RuleModel.Types.bind.type
            : RuleModel.Types.rule.type;
    }

    get family() {
        return this.isBind
            ? RuleModel.Types.bind.family
            : RuleModel.Types.rule.family;
    }

    get hasEmailActions() {
        return !!this.emailActions.length;
    }

    get emailActions() {
        return this.actions.filter(action => action.name === RuleActionModel.Names.sendEmail);
    }
}
